const Violet = {
  Violet: {
    _100: '#EDE9FE',
    _500: '#8B5CF6',
  },
};

export default Violet;
